import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Arkansas Invoice": {
    parameters: {
      linkUrls: [
        "https://arkansas.hazconnect.com/Account/Login.aspx",
        "https://www.dps.arkansas.gov/emergency-management/adem/plan-prepare/tier-ii-payment-form/",
        "https://otc.cdc.nicusa.com/Public2.aspx?portal=arkansas&organization=ADEM",
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Credential",
    state: "AR",
  },
  "Arkansas Portal": {
    parameters: {
      linkUrls: [
        "https://arkansas.hazconnect.com/Account/Login.aspx",
        "https://www.dps.arkansas.gov/emergency-management/adem/plan-prepare/tier-ii-payment-form/",
        "https://otc.cdc.nicusa.com/Public2.aspx?portal=arkansas&organization=ADEM",
        "https://encamp.slack.com/files/UN2B73EGY/F02T6HBKU1H/ar_fee_guidance.pdf",
      ],
      staffInputs: {
        fees: false,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AR",
  },
  "Arkansas Tier2 Submit": {
    parameters: {
      linkUrls: [
        "https://www.dps.arkansas.gov/emergency-management/adem/plan-prepare/tier-ii-payment-form/",
        "https://otc.cdc.nicusa.com/Public2.aspx?portal=arkansas&organization=ADEM",
        "https://encamp.slack.com/files/UN2B73EGY/F02T6HBKU1H/ar_fee_guidance.pdf",
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: false,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Tier2 Submit",
    state: "AR",
  },
  "Arkansas Portal Newly Not Reporting": {
    parameters: {
      staffInputs: {
        documentTypes: {
          proof: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "AR",
  },
};
